import axios from "axios";

/**
 * @classdesc Une inscription transferable suite a une demande de transfert
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class Transferable_Inscription
 */
export default class Transferable_Inscription {
    id_crypted;
    id_inscription;
    id_transfert_request;
    valid_after_enddate = 0;
    inscription;
    /**
     * Creates an instance of Transferable_Inscription.
     * @constructs
     * @kind function
     * @memberof Transferable_Inscription
     */
    constructor() { }


    async fetch() {
        let res = await axios.get("/transferable_inscription/get.php?id=" + this.id_crypted);
        if (res.data.error) {
            console.log(res.data.error);
            return await [false, res.data.error];
        } else {
            this.set(res.data);
            return await [true, res.data];
        }
    }

    set(data) {

        this.id_inscription = data.id_inscription;
        this.id_transfert_request = data.id_transfert_request;
        this.inscription = data.inscription;
        this.valid_after_enddate = data.valid_after_enddate;
    }
}